import HeroSection from "./HeroSection";
import LogosSection from "./LogosSection";
import TheProblem from "./TheProblem";
import SmartFormBuilder from "./SmartFormBuilder";
import WhyYouLoveIt from "./WhyYouLoveIt";
import CentralizedInbox from "./CentralizedInbox";
import HowItWorks from "./HowItWorks";
import UseCases from "./UseCases";
import InteractiveDemo from "./InteractiveDemo";
// import PricingPlans from "./PricingPlans";
import FAQSection from "./FAQSection";
import Testimonials from "./Testimonials";

const Home = () => {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-hidden">
      <main className="flex-grow bg-white overflow-x-hidden">
        <HeroSection />
        <LogosSection />
        <TheProblem />
        <SmartFormBuilder />
        <WhyYouLoveIt />
        <CentralizedInbox />
        <HowItWorks />
        <UseCases />
        <InteractiveDemo />
        {/* <PricingPlans /> */}
        <FAQSection />
        <Testimonials />
      </main>
    </div>
  );
};

export default Home;
